import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Button } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import "../../../../assets/css/handler_uld/handler_uld.css";

import Filter from '../../../../assets/images/ucm_dashboard/filter.svg'; 
import Flt1 from '../../../../assets/images/ucm_dashboard/flt1.svg'; 
import Flt2 from '../../../../assets/images/ucm_dashboard/flt2.svg'; 
import Flt4 from '../../../../assets/images/ucm_dashboard/flt4.svg';
import Eye from '../../../../assets/images/ucm_dashboard/eye.svg'; 
import Flts from '../../../../assets/images/ucm_dashboard/flts.svg'; 
import Fltb from '../../../../assets/images/ucm_dashboard/fltb.svg';  
import Cube from '../../../../assets/images/ucm_dashboard/cube.svg'; 
import Search from '../../../../assets/images/ucm_dashboard/search.svg'; 

const Dashboard = () => {
 
  return (
     <div className="ucm-page">
            <div className="top-controls">
                <div class="left-controls">
                    <select class="form-select warehouse-select">
                        <option selected>Warehouse</option>
                        <option>Warehouse B</option>
                        <option>Warehouse C</option>
                    </select>
                </div>


                <div className="right-controls">
                    <button className="filter-btn">
                        <img src={Filter} alt="" /> Filter
                    </button>

                    <div className="search-wrap position-relative">
                        <input className="search-input" placeholder="Search Flight" />
                        <span className='sricon'><img src={Search} alt='/'></img></span>
                    </div>
                </div>
            </div>
            <div className='ucm-btm'>
                <div className="summary-row">
                    <div className="summary-card bg-gry">
                        <div className="d-flex">
                            <div className="summary-icon gray">
                                <img src={Flt1} alt="/" />
                            </div>
                            <div className="summary-body">
                                <div className="summary-title">Scheduled Flight</div>
                            </div>
                        </div>

                        <div className="summary-body">
                            <div className="summary-count">Total 20</div>
                        </div>
                    </div>

                    <div className="summary-card bg-org">
                        <div className="d-flex">
                            <div className="summary-icon orange">
                                <img src={Flt2} alt="/" />
                            </div>
                            <div className="summary-body">
                                <div className="summary-title">In Progress Flight</div>
                            </div>
                        </div>

                        <div className="summary-body">
                            <div className="summary-count">Total 12</div>
                        </div>
                    </div>

                    <div className="summary-card bg-red">
                        <div className="d-flex">
                            <div className="summary-icon red">
                                <img src={Flt1} alt="/" />
                            </div>
                            <div className="summary-body">
                                <div className="summary-title">Overdue Flight</div>
                            </div>
                        </div>

                        <div className="summary-body">
                            <div className="summary-count">Total 6</div>
                        </div>
                    </div>

                    <div className="summary-card bg-green">
                        <div className="d-flex">
                            <div className="summary-icon green">
                                <img src={Flt4} alt="/" />
                            </div>
                            <div className="summary-body">
                                <div className="summary-title">Finalized Flight</div>
                            </div>
                        </div>

                        <div className="summary-body">
                            <div className="summary-count">Total 4</div>
                        </div>
                    </div>
                </div>
                <div className="columns-wrap">
                    <div className="row">

                        <Col md={6}>
                            <div className="col-head">
                                <h3>All Incoming Flight (UCM In)</h3>
                                <div className="col-sub">Here is able to monitor all relevant information</div>
                            </div>
                            <div className="cards-list">
                                <div className="flight-card">
                                    <div className="flight-top-row">
                                        <div className="flight-meta">
                                            <div className="flight-icon">
                                                <img src={Flts} alt="" />
                                            </div>
                                            <div>
                                                <div className="flight-no">AA123</div>
                                                <div className="d-flex align-items-center">
                                                    <div className="flight-date">Aug 5th, 2025</div>
                                                    <div className="flight-pieces">
                                                        <img src={Cube} alt="" /> 30/56
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="status-tag inprogress">In Progress</div>

                                        <button className="details-btn">
                                            <img src={Eye} alt="" /> Details
                                        </button>
                                    </div>

                                    <div className="flight-route-row">
                                        <div className="city-block">
                                            <div className="city-code">IST</div>
                                            <div className="city-name">Istanbul</div>
                                        </div>

                                        <div className="progress-area">
                                            <div className="progress-line">
                                                <div className="progress-track" />
                                                <div className="progress-fill" style={{ width: "65%" }} />

                                                <div className="progress-dot start" />
                                                <div className="progress-dot end" style={{ left: "100%" }} />

                                                <div className="plane-on-line">
                                                    <img src={Fltb} alt="" />
                                                </div>
                                            </div>

                                            <div className="eta-text">ETA - 3H 10M</div>
                                        </div>

                                        <div className="city-block right">
                                            <div className="city-code">CIA</div>
                                            <div className="city-name">Rome</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="col-head">
                                <h3>All Outgoing Flight (UCM Out)</h3>
                                <div className="col-sub">Here is able to monitor all relevant information</div>
                            </div>
                            <div className="cards-list">
                                <div className="flight-card">
                                    <div className="flight-top-row">
                                        <div className="flight-meta">
                                            <div className="flight-icon">
                                                <img src={Flts} alt="" />
                                            </div>
                                            <div>
                                                <div className="flight-no">AA123</div>

                                                <div className="d-flex align-items-center">
                                                    <div className="flight-date">Aug 5th, 2025</div>

                                                    <div className="flight-pieces">
                                                        <img src={Cube} alt="" /> 30/56
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="status-tag inprogress">In Progress</div>

                                        <button className="details-btn">
                                            <img src={Eye} alt="" /> Details
                                        </button>
                                    </div>
                                    <div className="flight-route-row">
                                        <div className="city-block">
                                            <div className="city-code">IST</div>
                                            <div className="city-name">Istanbul</div>
                                        </div>
                                        <div className="progress-area">
                                            <div className="progress-line">
                                                <div className="progress-track" />
                                                <div className="progress-fill" style={{ width: "65%" }} />

                                                <div className="progress-dot start" />
                                                <div className="progress-dot end" style={{ left: "100%" }} />

                                                <div className="plane-on-line">
                                                    <img src={Fltb} alt="" />
                                                </div>
                                            </div>
                                            <div className="eta-text">ETA - 3H 10M</div>
                                        </div>
                                        <div className="city-block right">
                                            <div className="city-code">CIA</div>
                                            <div className="city-name">Rome</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Dashboard